// Prevent multiple form submit
$('form').submit(function(){
    $(this).find('button[type="submit"]').prop('disabled', true);
});

// TODO: workaround - needs better implementation
$('form').change(function() {
    $(this).find('button[type="submit"]').prop('disabled', false);
});
